import { Container, Col } from "react-bootstrap";

import React from "react";
import {
    Box,
    FooterContainer,
    Row,
    Column,
    FooterLink,
    Heading,
} from "./FooterStylesStyleA";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFacebook } from "@fortawesome/free-brands-svg-icons"
import { faTwitter } from "@fortawesome/free-brands-svg-icons"
import { faXTwitter } from "@fortawesome/free-brands-svg-icons"
import { faInstagramSquare } from "@fortawesome/free-brands-svg-icons"
 

        {/* 

style={{
    color: "#0000008C",
}}
        */}

const FooterComponentStyleA = () => {
  return (
    <Box>
         <FooterContainer>
            <Row>
                <Column>

                    <Heading
                        style={{
                            color: "#ffffff",
                        }}
                        >MyIdea online&trade;
                    </Heading>

                    <FooterLink
                        style={{
                            color: "#ffffff",
                        }}
                        >
                       Copyright &copy; 2024 MPM project
                    </FooterLink>

                    <FooterLink
                        style={{
                            color: "#ffffff",
                        }}
                    >
                      WEB AGENCY
                    </FooterLink>

                    <FooterLink href="#"
                        style={{
                            color: "#ffffff",
                            fontStyle: "italic"
                        }}
                        >
                        info@mpmproject.it
                    </FooterLink>

                </Column>

                <Column>
                    <Heading
                        style={{
                            color: "#ffffff",
                        }}
                        >
                        About Us
                    </Heading>

                    <FooterLink href="https://www.mystudionline.it/"
                        style={{
                            color: "#ffffff",
                            fontStyle: "italic"
                        }}
                        >    
                        sitiWeb <b>MyStudio</b> 
                    </FooterLink>

                    <FooterLink href="https://www.myideaonline.it/"
                        style={{
                            color: "#ffffff",
                            fontStyle: "italic"
                        }}
                        >
                        sitiWeb <b>MyIdea</b> 
                    </FooterLink>

                    <FooterLink href="https://www.myshoponline.it/"
                        style={{
                            color: "#ffffff",
                            fontStyle: "italic"
                        }}
                        >
                        ecommerce <b>MyShop</b> 
                    </FooterLink>

                </Column>
                
                <Column>

                    <Heading
                        style={{
                            color: "#ffffff",
                        }}
                        >
                        &nbsp;
                    </Heading>
                    
                    <FooterLink href="https://www.myplanneronline.it/"
                        style={{
                            color: "#ffffff",
                            fontStyle: "italic"
                        }}
                        >
                        sitiWeb <b>MyPlanner</b> 
                    </FooterLink>

                    <FooterLink href="https://www.myplaceonline.it/"
                        style={{
                            color: "#ffffff",
                            fontStyle: "italic"
                        }}
                        >
                        sitiWeb <b>MyPlace</b> 
                    </FooterLink>

                </Column>

                <Column>
                
                    <Heading
                        style={{
                            color: "#ffffff",
                        }}
                        >
                        Social Media
                    </Heading>
                    
                    <row>

                        <FooterLink href="/#">
                            <FontAwesomeIcon icon={faFacebook}  
                                        style={{
                                            marginLeft: "0px",
                                            color: "orange",
                                            height: "40px",
                                        }}
                            >
                            </FontAwesomeIcon>
                        </FooterLink>

                        <FooterLink href="#">
                            <FontAwesomeIcon icon={faInstagramSquare}  
                                        style={{
                                            marginLeft: "20px",
                                            color: "orange",
                                            height: "40px",
                                        }}
                            >
                            </FontAwesomeIcon>
                        </FooterLink>

                        <FooterLink href="#">
                            <FontAwesomeIcon icon={faTwitter}  
                                        style={{
                                            marginLeft: "20px",
                                            color: "orange",
                                            height: "40px",
                                        }}
                            >
                            </FontAwesomeIcon>
                        </FooterLink>

                        <FooterLink href="https://www.mpmproject.it"
                            style={{
                                color: "#ffffff",
                                fontStyle: "italic"
                            }}
                            >
                            www.mpmproject.it
                        </FooterLink>

                     </row>

                </Column>
            </Row>
        </FooterContainer>
 
    </Box>
  );
};


export default FooterComponentStyleA;
